// extracted by mini-css-extract-plugin
export default {"light":"styles_light__3udDQ","dark":"styles_dark__mtfOr","icon":"styles_icon__rytdc","preview":"styles_preview__+gsHO"};